
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M6.752 10.109c1.962-3.545 3.951-6.559 3.97-6.588a1.011 1.011 0 011.688 0c.02.03 2.01 3.043 3.97 6.588 2.692 4.864 4.056 8.399 4.056 10.504a8.537 8.537 0 01-2.62 6.32 9.449 9.449 0 01-12.499 0 8.537 8.537 0 01-2.62-6.32c0-2.105 1.364-5.64 4.055-10.504z","stroke":"currentColor","stroke-width":"1.393"}}),_c('path',{attrs:{"d":"M5.518 21.165a5.916 5.916 0 004.893 5.258","stroke":"currentColor","stroke-width":"1.393","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M13.099 7.663a7.663 7.663 0 1115.325 0 7.663 7.663 0 01-15.325 0z","fill":"#5EC7F2"}}),_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M17.992 6.548c.108-.2.26-.355.46-.468.204-.117.447-.176.728-.176.337 0 .641.09.912.268.27.174.483.43.636.766.158.332.237.726.237 1.18 0 .455-.079.85-.237 1.188a1.788 1.788 0 01-.636.766c-.27.174-.575.26-.912.26-.28 0-.523-.055-.728-.168a1.208 1.208 0 01-.46-.475v2.66h-1.7V5.957h1.7v.59zm1.25 1.57c0-.23-.06-.408-.177-.536a.587.587 0 00-.452-.192.587.587 0 00-.452.192c-.117.128-.176.307-.176.536 0 .23.059.41.176.537a.587.587 0 00.452.191.587.587 0 00.452-.191c.118-.128.176-.307.176-.537zm7.276-3.264v5.425h-1.7V8.164H23.2v2.115H21.5V4.854h1.7v1.954h1.617V4.854h1.701z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(15.908 2.28)","d":"M0 0h11v12H0z"}})])])])
          )
        }
      }
    